var map = {
	"./template.betgalaxy": 2132,
	"./template.betgalaxy.tsx": 2132,
	"./template.betprofessor": 2019,
	"./template.betprofessor.tsx": 2019,
	"./template.betroyale": 2020,
	"./template.betroyale.tsx": 2020,
	"./template.default": 710,
	"./template.default.tsx": 710,
	"./template.fiestabet": 1959,
	"./template.fiestabet.tsx": 1959,
	"./template.forsport": 1960,
	"./template.forsport.tsx": 1960,
	"./template.goldenrush": 2021,
	"./template.goldenrush.tsx": 2021,
	"./template.juicybet": 2022,
	"./template.juicybet.tsx": 2022,
	"./template.junglebet": 2023,
	"./template.junglebet.tsx": 2023,
	"./template.oldgill": 2024,
	"./template.oldgill.tsx": 2024,
	"./template.puntcity": 2025,
	"./template.puntcity.tsx": 2025,
	"./template.puntgenie": 1988,
	"./template.puntgenie.tsx": 1988,
	"./template.questbet": 2026,
	"./template.questbet.tsx": 2026,
	"./template.sterlingparker": 2027,
	"./template.sterlingparker.tsx": 2027,
	"./template.sugarcastle": 2028,
	"./template.sugarcastle.tsx": 2028,
	"./template.ts": 1003,
	"./template.vikingbet": 2133,
	"./template.vikingbet.tsx": 2133,
	"./template.volcanobet": 1993,
	"./template.volcanobet.tsx": 1993,
	"./template.wellbet": 2029,
	"./template.wellbet.tsx": 2029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2808;